import { UTA_FORM_TA_FIELD_ENUM } from '@components-member/TradingAccounts/AccountCreate/enums';
import { IBCODE_FIELD, LEVERAGE_FIELD } from '@components-member/TradingAccounts/AccountCreate/sharedFields';
import { TYPE_FIELD } from '@components-member/shared/forms/formFields';
import { IModalFormField } from '@components-member/socialTrading/social.interfaces';
import { validationService } from '@components-shared/forms/validators';
import { keyMap } from '@locales/lokalise/keyMap';

export const SELF_ACCOUNT_FIELDS: IModalFormField[] = [
  {
    ...TYPE_FIELD,
    name: UTA_FORM_TA_FIELD_ENUM.type,
    title: keyMap.sharedFieldsType,
    attributes: { autoComplete: 'off' },
    required: true,
    className: 'lg-4 md-4',
  },
  {
    ...LEVERAGE_FIELD,
    attributes: { autoComplete: 'off' },
    className: 'lg-4 md-4',
  },
  {
    ...IBCODE_FIELD,
    className: 'lg-4 md-4',
  },
];

export const DEMO_ACCOUNT_FIELDS: IModalFormField[] = [
  {
    ...TYPE_FIELD,
    name: UTA_FORM_TA_FIELD_ENUM.type,
    title: keyMap.sharedFieldsType,
    attributes: { autoComplete: 'off' },
    required: true,
    className: 'lg-4 md-4',
  },
  {
    ...LEVERAGE_FIELD,
    attributes: { autoComplete: 'off' },
    className: 'lg-4 md-4',
  },
  {
    name: UTA_FORM_TA_FIELD_ENUM.initialDeposit,
    type: 'number',
    defaultValue: '1000',
    step: 100,
    precision: 2,
    allowNegativeValues: false,
    title: keyMap.tradingAccountsInitialDeposit,
    validator: validationService.isGreaterThan(0),
    attributes: { autoComplete: 'off' },
    required: true,
    className: 'lg-4 md-4',
  },
];
